export enum EventType {
  Create = 'Create',
  Update = 'Update',
  Submit = 'Submit',
  Accept = 'Accept',
  Reject = 'Reject'
}

export interface InterfaceObject {
  Object_Code: string;
  Entity?: {
    Entity_ID: string;
    Role_Type: string;
  };
  Contract?: {
    Contract_ID: string;
    Lock_GUID?: string;
  };
}
